import genericApi from './genericApi';

import ApiResponse from '../models/ApiResponse';
import AccountTransaction from '../models/AccountTransaction';
import ForwarderGhaInvoiceBalance from '../models/ForwarderGhaInvoiceBalance';

const invoiceReqHandler = {

  getAccountBalance: (id: number): Promise<ApiResponse<ForwarderGhaInvoiceBalance>> => {

    return genericApi.get(`acc/${id}`);
  },

  setInvoiceAccountTransaction: (fwdId: number, transaction: AccountTransaction) : Promise<ApiResponse<boolean>> => {
    return genericApi.post(`acc/${fwdId}`, transaction);
  },
};

export default invoiceReqHandler;